import { Box, Grid, useTheme } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useDealData } from 'api/aws/deals/useDealData'
import { useEntitiesFromSearch } from 'api/search'
import { useNavigate, useParams } from 'react-router-dom'
import { GROBxLoader } from 'theme/components'
import { useNewContactsById } from '../../api/customHooks/useNewContactsById'
import { useLayoutContext } from '../../context/LayoutProvider/LayoutProvider'
import DealInfoCard from './DealInfoCard'
import { gridStyles } from './style'

const DetailsContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  padding: 2,
  transition: 'height 0.3s ease',
  height: '98%',
  flex: 1,
}))

const DealsDetails = () => {
  const { PK, SK } = useParams()
  const dealId = SK?.split('DEAL_')?.[1]
  const { navOpen } = useLayoutContext()
  const theme = useTheme()
  const { deal } = useDealData(PK, SK, dealId)
  const navigate = useNavigate()
  // Retrieve contacts associated with the deal
  const newContactIds = deal && deal.contacts && Array.isArray(deal.contacts) ? deal.contacts : []
  const { newContacts } = useNewContactsById(newContactIds, 'dealDetails-contacts')
  const { isItemsLoading } = useEntitiesFromSearch()

  const handleNavigate = () => {
    if (deal?.id) {
      navigate(`/deals/${deal?.PK}/${deal.SK}/agreement`)
    } else {
      console.error('No deal ID found')
    }
  }
  const handleEdit = () => {
    handleNavigate()
  }

  return (
    <>
      <Grid container spacing={0} justifyContent="center" sx={{ ...gridStyles(theme) }}>
        <Grid
          container
          sx={{
            p: 1,
            height: '100dvh',
            maxHeight: 'calc(100dvh - 205px)',
          }}
        >
          {isItemsLoading ? (
            <GROBxLoader open={isItemsLoading} message="Syncing Details" />
          ) : (
            <DealInfoCard key={dealId} newContacts={newContacts} />
          )}
        </Grid>
      </Grid>
    </>
  )
}

export default DealsDetails
